import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';

import store, { persistor } from './store';
import GlobalStyles from './styles/GlobalStyles';
import NavBar from './components/Navbar';
// import Routes from './routes';

const baseName = process.env.REACT_APP_BASENAME;
function App() {
  return (
    <Provider store={store}>
      <PersistGate persistor={persistor}>
        <BrowserRouter basename={`${baseName}`}>
          <NavBar />
          {/* <Routes />  As rotas estao na NAVBAR */}
          <GlobalStyles />
          <ToastContainer autoClose={2000} className="toast-container" />
        </BrowserRouter>
      </PersistGate>
    </Provider>
  );
}

export default App;
